import { createBrowserRouter, redirect } from "react-router-dom";

import { AdminViewPage } from "../pages/protected/AdminViewPage";
import { ConflictManagementPage } from "../pages/protected/contract/ConflictManagementPage";
import { ContractDashboardPage } from "../pages/protected/ContractDashboardPage";
import { ContractPage } from "../pages/protected/contract/ContractPage";
import { DownloadSoftwareBundleHotfixesPage } from "../pages/public/DownloadSoftwareBundleHotfixesPage";
import { DownloadSoftwareBundlePage } from "../pages/public/DownloadSoftwareBundlePage";
import { ErrorPage } from "../pages/public/ErrorPage";
import { InstallGuidePage } from "../pages/protected/contract/InstallGuidePage";
import { InstallationChecklistPage } from "../pages/public/InstallationChecklistPage";
import { LandingPage } from "../pages/public/LandingPage";
import { LoginPage } from "../pages/public/LoginPage";
import { ProductPage } from "../pages/protected/contract/ProductPage";
import { Routes } from "./Routes";
import { UpdateCheck } from "../pages/public/UpdateCheckPage";
import { UserAuthRolePage } from "../pages/protected/contract/UserAuthRolePage";
import { ProjectAnalysisProductsPage } from "../features/adminView/ProjectAnalysisProductsPage";
import { AdminViewType } from "../features/adminView/types/AdminViewType";

/**
 * This constant provides access to the routes of this app and its corresponding components.
 */
export const AppRouter = createBrowserRouter([
  {
    path: Routes.projectAnalysisProducts.origin,
    element: <ProjectAnalysisProductsPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.updateSyncProducts.origin,
    element: <ProjectAnalysisProductsPage requiredView={AdminViewType.UPDATE_SYNC} />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.systemConflictManagement.origin,
    element: <ConflictManagementPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.systemInstallChecklist.origin,
    element: <InstallGuidePage />,
    errorElement: <ErrorPage />,
  },
  {
    path: `${Routes.adminView.origin}/*`,
    element: <AdminViewPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.contracts.origin,
    element: <ContractDashboardPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.contract.origin,
    element: <ContractPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.contractProduct.origin,
    element: <ProductPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.homePage.origin,
    errorElement: <ErrorPage />,
    loader: async () => {
      return redirect(Routes.contracts.toPath());
    },
  },
  {
    path: Routes.contractUserAuthRole.origin,
    element: <UserAuthRolePage />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.login.toPath(),
    element: <LoginPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.welcome.origin,
    element: <LandingPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.updateCheck.origin,
    element: <UpdateCheck />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.downloadSoftwareBundle.origin,
    element: <DownloadSoftwareBundlePage />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.downloadSoftwareBundleHotfixes.origin,
    element: <DownloadSoftwareBundleHotfixesPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: Routes.installationChecklist.origin,
    element: <InstallationChecklistPage />,
    errorElement: <ErrorPage />,
  },
]);
